import app from '@/App.vue'
import '@/assets/main.css'
import router from '@/router'
import { createApp } from 'vue'
import { firebaseConfig } from "@/config/firebaseConfig";
import { initializeApp } from "firebase/app";
import { createPinia } from 'pinia';

const pinia = createPinia();

initializeApp(firebaseConfig);

createApp(app)
    .use(router)
    .use(pinia)
    .mount('#app')